<template>
  <div class="section-card">
    <div class="section-card-header">
      <div class="left-view">
        <div class="expand-icon" v-if="expandable" @click="toggleExpand">
          <i class="el-icon-remove" v-if="isExpand"></i>
          <i class="el-icon-circle-plus" v-else></i>
          <span :style="titleStyle">{{ title }}</span>
          <slot name="title"></slot>
        </div>
        <span v-else :style="titleStyle">
          {{ title }}
          <slot name="title"></slot>
        </span>
        <slot name="leftView"></slot>
      </div>
      <span>
        <slot name="button"></slot>
      </span>
    </div>
    <transition name="section-card-content">
      <div class="section-card-content" v-show="isExpand">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'section-card',
  props: {
    title: {
      type: String
    },
    titleStyle: {
      type: Object
    },
    expandable: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExpand: this.expand
    }
  },
  watch: {
    expand(newVal) {
      this.isExpand = newVal
    }
  },
  methods: {
    toggleExpand() {
      this.isExpand = !this.isExpand
      this.$emit('update:expand', this.isExpand)
      this.$emit('expandClick', this.isExpand)
    }
  }
}
</script>
<style lang="scss">
.section-card {
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  &-header {
    display: flex;
    flex-direction: row;
    background-color: #fff;
    padding: 12px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
    .left-view {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #101010;
    }
    .expand-icon {
      cursor: pointer;
      i {
        margin-right: 4px;
        color: #444;
      }
    }
  }
  &-content {
    padding: 16px 12px;
    overflow: hidden;
  }
  .section-card-content-enter-active,
  .section-card-content-leave-active {
    transition: all 0.3s ease;
    max-height: 9000px;
  }

  .section-card-content-enter,
  .section-card-content-leave-to {
    max-height: 0;
    opacity: 0;
  }
}
</style>
